module.exports = __webpack_public_path__ + "img/13.7e849e97.jpg";